import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, take, withLatestFrom } from 'rxjs/operators';
import { EventsFacade } from '../../+state/events/events.facade';
import { EventsEntity } from '../../+state/events/models/events-entity';

@Component({
  selector: 'angular-community-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class EventsComponent implements OnInit {
  filteredEvents$: Observable<EventsEntity[]>;
  seriesSubject: BehaviorSubject<Series[]> = new BehaviorSubject([
    {
      label: 'Americas - English',
      value: 'americas-en',
      active: true,
    },
    {
      label: 'Europe & Africa - English',
      value: 'europe-africa-en',
      active: true,
    },
  ]);
  showPastEventsSubject = new BehaviorSubject(false);
  now = new Date();

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private eventsFacade: EventsFacade
  ) {
    this.titleService.setTitle('Angular Community Meetup | Events');
  }

  ngOnInit(): void {
    this.now.setDate(this.now.getDate() - 1);
    this.eventsFacade.init();
    this.filteredEvents$ = combineLatest([
      this.eventsFacade.allEvents$,
      this.seriesSubject,
      this.showPastEventsSubject,
    ]).pipe(
      map(([events, allSeries, showPastEvents]) => {
        let result = events.filter((event) => {
          const isPast =
            new Date(event.date).getTime() - this.now.getTime() < 0;
          const series = allSeries.find(
            (series) => series.value === event.series
          );
          return series?.active && isPast === showPastEvents;
        });
        if (showPastEvents === true) {
          result = result.reverse();
        }

        return result;
      })
    );
    this.route.params
      .pipe(withLatestFrom(this.seriesSubject), take(1))
      .subscribe(([params, allSeries]) => {
        if (params.series) {
          const updatedSeries = allSeries.map((series) => ({
            ...series,
            active: series.value === params.series,
          }));
          this.seriesSubject.next(updatedSeries);
        }
      });
  }

  seriesClicked(index: number): void {
    this.seriesSubject.pipe(take(1)).subscribe((oldSeries) => {
      const newSeries = [...oldSeries];
      newSeries.splice(index, 1, {
        ...oldSeries[index],
        active: !oldSeries[index].active,
      });
      this.seriesSubject.next(newSeries);
    });
  }

  pastEventsChanged(data): void {
    this.showPastEventsSubject.next(data.checked);
  }
}

interface Series {
  label: string;
  value: string;
  active: boolean;
}
